module.exports = __webpack_public_path__ + "static/img/logo3.abe54623.jpg";